import { createGlobalState } from 'react-hooks-global-state';

const { setGlobalState, useGlobalState } = createGlobalState({
  headerProps: {
    href: './',
    alt: 'Guerini',
    imageURL: './assets/images/logo.png',
    accountDropdown: {
      // avatarURL: null,
      name: '',
      description: '',
      // options: [
        // { icon: 'user', value: 'Profile', to: '/profile' },
        // { isDivider: true },
        // { icon: 'log-out', value: 'Sair', to: './signout'},
      // ],
    },
    // notificationsTray: {
      // notificationsObjects: [
        // {
        //   unread: true,
        //   message: (
        //     <React.Fragment>
        //       <strong>Nathan</strong> pushed new commit: Fix page load performance
        //       issue.
        //     </React.Fragment>
        //   ),
        //   time: '10 minutes ago',
        // },
        // {
        //   unread: true,
        //   message: (
        //     <React.Fragment>
        //       <strong>Alice</strong> started new task: Tabler UI design.
        //     </React.Fragment>
        //   ),
        //   time: '1 hour ago',
        // },
        // {
        //   unread: false,
        //   message: (
        //     <React.Fragment>
        //       <strong>Rose</strong> deployed new version of NodeJS REST Api // V3
        //     </React.Fragment>
        //   ),
        //   time: '2 hours ago',
        // },
      // ],
      // unread: 
    // }
  },
  navProps: {
    itemsObjects: [{
      value: 'Inicio',
      to: './',
      icon: 'home',
      useExact: true,
    },
    {
      value: 'Empreendimentos',
      to: './projects',
      icon: 'folder',
      useExact: true,
    },
    {
      value: 'Perfil',
      to: './profile',
      icon: 'user',
      useExact: true,
    },
    {
      value: 'Sair',
      to: './signout',
      icon: 'log-out',
      useExact: true,
    }]
  }
});

export const setName = (name) => {
  setGlobalState('headerProps', (value) => {
    value.accountDropdown.name = name;

    return value;
  });
};

export { useGlobalState };
